export default {
  manifest: {
    title: 'Discover ESG Initiatives That Guide Our Actions',
    desc: 'Our Commitment to Responsible and Transparent Practices',
    button: 'Access Our Manifesto',
  },
}
